import { AnyMongoAbility, subject as newSubject } from '@casl/ability';

import { Conditions, AnyPermission, AnyPermissionString } from '../types';

import { parsePermissionString } from './parse-permission-string';

export type AbilityHelpers = {
  ability: AnyMongoAbility;
  hasAllPermissions: (
    permissions: (AnyPermission | AnyPermissionString)[],
    subjectProperties?: Conditions
  ) => boolean;
  hasAnyPermission: (
    permissions: (AnyPermission | AnyPermissionString)[],
    subjectProperties?: Conditions
  ) => boolean;
  hasPermission: (
    permission: AnyPermission | AnyPermissionString,
    subjectProperties?: Conditions
  ) => boolean;
};

export const createAbilityHelpers = (
  ability: AnyMongoAbility,
  subjectProperties?: Conditions
): AbilityHelpers => {
  return {
    hasAllPermissions(permissions, additionalSubjectProperties) {
      return permissions.every((permission) =>
        this.hasPermission(permission, additionalSubjectProperties)
      );
    },
    hasAnyPermission(permissions, additionalSubjectProperties) {
      return permissions.some((permission) =>
        this.hasPermission(permission, additionalSubjectProperties)
      );
    },
    hasPermission(permission, additionalSubjectProperties) {
      const {
        action,
        subject,
        type = 'can',
        conditions,
      } = typeof permission === 'string' ? parsePermissionString(permission) : permission;
      return ability[type](
        action,
        newSubject(subject, {
          ...subjectProperties,
          ...additionalSubjectProperties,
          ...conditions,
        })
      );
    },
    ability,
  } satisfies AbilityHelpers;
};
